import Table from './DataTable';
import { sortBy, filterByExactly, filterByContaining, useControllableTable } from './utils';

export const DataTable = {
  Table,
  sortBy,
  filterByExactly,
  filterByContaining,
  useControllableTable
};
